"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var FormError_1 = require("./FormError");
var FormLabel_1 = require("./FormLabel");
function FormControl(props) {
    var children = props.children, htmlFor = props.htmlFor, error = props.error, label = props.label, labelId = props.labelId, errorId = props.errorId, required = props.required;
    var classes = styles_1.useStyles(createStyles).classes;
    return (react_1.default.createElement("div", { className: classes.formControl },
        label && react_1.default.createElement(FormLabel_1.FormLabel, { id: labelId, required: required, style: classes.label, htmlFor: htmlFor, label: label }),
        children,
        error && (react_1.default.createElement(FormError_1.FormError, { id: errorId, style: classes.error, role: 'alert' }, error))));
}
exports.FormControl = FormControl;
var createStyles = function () { return ({
    formControl: {},
    label: {
        display: 'block',
        marginBottom: '0.25rem',
        lineHeight: '20px',
    },
    error: {
        marginTop: '0.25rem',
        lineHeight: '20px',
    },
}); };
//# sourceMappingURL=FormControl.js.map